module.exports = __webpack_public_path__ + "img/construction.313a78e7.svg";